export default __webpack_public_path__ + "c187ca0d37927cb6f91985bcbe3e5ae5.png";